import { useEffect, useState } from 'react';
import { ACTION_TYPES, useSupplierSearchDispatch, useSupplierSearchState } from './supplier-search-context';
import SupplierAppService from '../../../../application/platform/sge/supplier/supplier-app-service';
import LocationAppService from '../../../../application/platform/base/location-app-service';
import { useFeedback } from '../../../../hooks/use-feedback';
import { ISupplierAddRequest } from '../../../../model/sge/supplier/request/supplier-add-edit-request';
import { ISupplierPagedResponse } from '../../../../model/sge/supplier/response/supplier-paged-response';

export const useSupplierSearchController = () => {
    const dispatch = useSupplierSearchDispatch();
    const state = useSupplierSearchState();
    const { showSuccess, showError, confirmDelete, withLoading } = useFeedback();
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        LocationAppService.listCountries()
            .then((countries) => dispatch({ type: ACTION_TYPES.setCountries, payload: countries }))
            .catch((error: any) => showError('Não foi possível carregar a lista de países', error));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Filtros
    function handleOnChange(e: any) {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { term: e.target.value || undefined } });
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0 } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0, term: undefined } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handlePaginationChange(page: number, pageSize: number) {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page, pageSize } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    // Cadastro/edição: a listagem não traz endereço e contato, então a edição busca o registro completo
    async function openDrawer(row?: ISupplierPagedResponse) {
        if (!row) {
            dispatch({ type: ACTION_TYPES.openDrawer });
            return;
        }
        try {
            const supplier = await withLoading(() => SupplierAppService.getById(row.id));
            dispatch({ type: ACTION_TYPES.openDrawer, payload: supplier });
        } catch (error: any) {
            showError('Não foi possível carregar o fornecedor', error);
        }
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    async function handleSave(request: ISupplierAddRequest) {
        const editing = state.drawer.record;
        setIsSaving(true);
        try {
            if (editing) {
                await SupplierAppService.edit(editing.id, request);
                showSuccess('Fornecedor atualizado com sucesso!');
            } else {
                await SupplierAppService.add(request);
                showSuccess('Fornecedor adicionado com sucesso!');
            }
            closeDrawer();
            dispatch({ type: ACTION_TYPES.triggerSearch });
        } catch (error: any) {
            showError('Não foi possível salvar o fornecedor', error);
        } finally {
            setIsSaving(false);
        }
    }

    async function removeSupplier(row: ISupplierPagedResponse) {
        try {
            await SupplierAppService.remove(row.id);
            showSuccess('Fornecedor excluído com sucesso!');
            dispatch({ type: ACTION_TYPES.triggerSearch });
        } catch (error: any) {
            showError('Não foi possível excluir o fornecedor', error);
        }
    }

    function handleDelete(row: ISupplierPagedResponse) {
        confirmDelete(`Tem certeza que deseja excluir o fornecedor "${row.personName || ''}"?`, () => { removeSupplier(row); });
    }

    return { isSaving, handleOnChange, handleSearch, handleClearFilters, handlePaginationChange, openDrawer, closeDrawer, handleSave, handleDelete };
};
